import { formatDate } from '@erp/shared';

import { Card } from '../components/ui/card.tsx';
import { useSession } from '../lib/session.ts';

export function HomePage() {
  const { data: session } = useSession();
  if (!session) return null;
  const firstName = session.user.fullName.split(' ')[0] ?? session.user.fullName;
  return (
    <div className="space-y-6">
      {/* Brand moment: white text sits on the dark (left) part of the gradient. */}
      <div className="bg-brand rounded-2xl px-6 py-7 sm:px-8">
        <h1 className="text-2xl font-semibold sm:text-3xl">Hola, {firstName}</h1>
        <p className="mt-1 text-white/85">
          {session.tenant.name} · {formatDate(new Date(), session.tenant.timezone)}
        </p>
      </div>
      <Card>
        <h2 className="font-semibold">Estamos construyendo tu ERP</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Contactos, propiedades, negocios y comisiones llegarán en las próximas fases. Por ahora
          puedes gestionar tu cuenta
          {session.permissions.includes('users.manage')
            ? ', los usuarios y los roles de tu inmobiliaria.'
            : '.'}
        </p>
      </Card>
    </div>
  );
}
